import {useCallback} from 'react';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {Box} from '@mui/material';

import {PaymentLinkLogo} from '../paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';
import {SplitsLandingPromoCard} from '../splits/components/SplitsLandingPromoCard';
import {SplitsOtpCard} from '../splits/components/SplitsOtpCard';
import {SplitsPhoneCard} from '../splits/components/SplitsPhoneCard';

import {GroupsInvitationCard} from './components/GroupsInvitationCard/GroupsInvitationCard';
import {GroupsSelectMemberCard} from './components/GroupsSelectMemberCard/GroupsSelectMemberCard';
import {
  GroupsViewModelProvider,
  useGroupsViewModelProvider,
} from './GroupsViewModelContext';
import {GROUPS_VIEW_STEP} from './models/constants';

function GroupsLandingContent() {
  const {
    step,
    canGoBack,
    inviterName,
    groupName,
    onOpenAccount,
    onContinueFromLanding,
    isLoadingGroup,
    selectableParticipants,
    selectedParticipant,
    groupId,
    onSelectParticipant,
    onContinueFromSelectParticipant,
    handleBack,
    phone,
    setPhone,
    isPhoneValid,
    onSubmitPhone,
    formattedPhone,
    otp,
    setOtp,
    resendSeconds,
    canResend,
    onResendOtp,
    onSubmitOtp,
  } = useGroupsViewModelProvider();
  const renderStepCard = useCallback(() => {
    switch (step) {
      case GROUPS_VIEW_STEP.LANDING:
        return (
          <GroupsInvitationCard
            inviterName={inviterName}
            groupName={groupName}
            isLoadingSplitData={isLoadingGroup}
            onContinueFromLanding={onContinueFromLanding}
          />
        );
      case GROUPS_VIEW_STEP.SELECT_MEMBER:
        return (
          <GroupsSelectMemberCard
            groupId={groupId}
            inviterName={inviterName}
            participants={selectableParticipants}
            selectedParticipant={selectedParticipant}
            onSelectParticipant={onSelectParticipant}
            onContinueFromSelectParticipant={onContinueFromSelectParticipant}
          />
        );
      case GROUPS_VIEW_STEP.PHONE_INPUT:
        return (
          <SplitsPhoneCard
            phone={phone}
            setPhone={setPhone}
            isPhoneValid={isPhoneValid}
            onSubmitPhone={onSubmitPhone}
            inviterName={inviterName}
            isGroupJoinFlow
          />
        );
      case GROUPS_VIEW_STEP.OTP:
      default:
        return (
          <SplitsOtpCard
            formattedPhone={formattedPhone}
            otp={otp}
            setOtp={setOtp}
            canResend={canResend}
            resendSeconds={resendSeconds}
            onResendOtp={onResendOtp}
            onSubmitOtp={onSubmitOtp}
            inviterName={inviterName}
            isGroupJoinFlow
          />
        );
    }
  }, [
    canResend,
    formattedPhone,
    groupId,
    groupName,
    inviterName,
    isLoadingGroup,
    isPhoneValid,
    onContinueFromLanding,
    onContinueFromSelectParticipant,
    onResendOtp,
    onSelectParticipant,
    onSubmitOtp,
    onSubmitPhone,
    otp,
    phone,
    resendSeconds,
    selectableParticipants,
    selectedParticipant,
    setOtp,
    setPhone,
    step,
  ]);

  return (
    <section className="splits-landing">
      <Box className="splits-landing-container">
        <Box className="splits-landing-logo">
          {canGoBack && (
            <ArrowBackIosNewIcon
              className="back-icon"
              onClick={handleBack}
            />
          )}

          <Box className="logo-container">
            <PaymentLinkLogo />
          </Box>
        </Box>

        {renderStepCard()}

        <SplitsLandingPromoCard onOpenAccount={onOpenAccount} />
      </Box>
    </section>
  );
}

const GroupsPage = () => (
  <GroupsViewModelProvider>
    <GroupsLandingContent />
  </GroupsViewModelProvider>
);

export default GroupsPage;
